import { AccessibilityType } from '~client/model/accessibility-type';
import { SeatConfigurationCategoryItemFormData } from '~admin/view/components/details/event-details/event-location-details/seat-configuration-category-item-fields.component';
import { getTranslationInitialValues } from '~admin/view/components/create-event/helper/create-event-initial-values.helper';
import { Language } from '~common/i18n';

/**
 * Returns initial values for location details
 */
export const getSeatConfigurationCategoryInitialValues = (): SeatConfigurationCategoryItemFormData => ({
  name: [getTranslationInitialValues(Language.ENGLISH)],
  accessibilityType: AccessibilityType.STREAMING,
  rules: [getTranslationInitialValues(Language.ENGLISH)],
  emailRules: [getTranslationInitialValues(Language.ENGLISH)],
  categoryDetail: [getTranslationInitialValues(Language.ENGLISH)],
  yoopCount: 5000,
});



// WEBPACK FOOTER //
// ./view/components/create-event/helper/create-seat-configuration-initial-values.helper.ts